var exports = {
  "UX": "PlutoniumUpsell.module__upsell___OE1jZT",
  "Kk": "PlutoniumUpsell.module__icon___OE1jZT",
  "Qs": "PlutoniumUpsell.module__content___OE1jZT",
  "Qq": "PlutoniumUpsell.module__text___OE1jZT",
  "o1": "PlutoniumUpsell.module__actions___OE1jZT",
  "R3": "PlutoniumUpsell.module__dismissLink___OE1jZT",
};

module.exports = exports;
